import { useEffect, useState } from "react";
import { fget } from "../API/callsAPI";

export const ProjectsPageDataHook = () => {
  const [testData, setTestData] = useState("test data passed successfully");
  const [projectItems, setProjectItems] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [trackableClass, setTrackableClass] = useState([]);
  const [myTeams, setMyTeams] = useState([]);

  const fetchActiveProjects = async () => {
    try {
      const projectsRes = await fget({
        url: `project/?page=1`,
      });
      setProjectItems(projectsRes.data.results);
    } catch (error) {
      console.log(error);
    }
  };

  //fetch user details before registering other routes.
  const getUserDetails = async () => {
    const accessToken = document.cookie.replace(
      /(?:(?:^|.*;\s*)access\s*\=\s*([^;]*).*$)|^.*$/,
      "$1",
    );
    console.log("its getting replaced?");
    if (accessToken) {
      const userId = JSON.parse(atob(accessToken.split(".")[1])).user_id;
      try {
        const res = await fget({ url: `user/${userId}/` });
        setLoggedInUser(res.data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  async function fetchTrackableClass() {
    //
    try {
      const trackableClasses = await fget({
        url: "trackables/trackable-classes/",
      });
      setTrackableClass(trackableClasses.data);
    } catch (error) {
      console.log(error);
    }
  }

  const handleGetTeams = async () => {
    try {
      const res = await fget({ url: "project-space/" });
      if (res.status === 200) {
        setMyTeams(res.data.results);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("is this running?");
    fetchActiveProjects();
    getUserDetails();
    fetchTrackableClass();
    handleGetTeams();
  }, []);

  return {
    testData,
    projectItems,
    loggedInUser,
    trackableClass,
    myTeams,
    setMyTeams,
  };
};
